import styled from 'styled-components';
import { colors, typography, spacing, borderRadius, shadows, breakpoints } from '../../styles/theme';

export const Card = styled.div`
  max-width: 800px;
  margin: ${spacing['2xl']} auto 0;
  padding: ${spacing.xl};
  border-radius: ${borderRadius['3xl']};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.md};
  text-align: center;

  ${props => props.$tone === 'light' ? `
    background: ${colors.neutral.white};
    border: 2px solid ${colors.primary.teal};
    color: ${colors.primary.teal};
    box-shadow: ${shadows.card};
  ` : `
    background: ${colors.gradients.teal};
    color: ${colors.neutral.white};
    box-shadow: ${shadows.lg};
  `}

  @media (max-width: ${breakpoints.md}) {
    padding: ${spacing.lg};
  }
`;

export const Title = styled.h3`
  font-size: ${typography.fontSize['2xl']};
  font-weight: ${typography.fontWeight.bold};
  color: inherit;
  margin: 0;

  @media (max-width: ${breakpoints.md}) {
    font-size: ${typography.fontSize.xl};
  }
`;

export const Outcome = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${spacing.sm};
  font-size: ${typography.fontSize.lg};
  font-weight: ${typography.fontWeight.semibold};
  color: inherit;
  line-height: ${typography.lineHeight.normal};

  svg {
    font-size: 1.25rem;
    flex-shrink: 0;
    color: ${props => (props.$win ? colors.secondary.green : colors.secondary.red)};
  }

  @media (max-width: ${breakpoints.md}) {
    font-size: ${typography.fontSize.base};
  }
`;

export const Closing = styled.p`
  font-size: ${typography.fontSize.base};
  color: inherit;
  opacity: 0.95;
  font-style: italic;
  margin: 0;
  max-width: 560px;
`;
